import React from "react";

const URL404 = () => (
    <div>
        <h2>404 ERROR: <code>{window.location.pathname}</code> is not a valid URL</h2>
    </div>
);

export default URL404;